import { useMemo } from "react";
import { useSearch } from "wouter";
import queryString from 'query-string';

function useLocationNext() {
    const search = useSearch();
    const { next = null } = useMemo(() => queryString.parse(search) || {}, [search]);
    return next;
}

export default useLocationNext;
